import styled, { css } from "styled-components";
import { textStyles } from "../../shared/textStyles";
import { tombac } from "../../shared/tombac";
import { propStyling } from "../../shared/propStyling/propStyling";
export const InlineText = styled.span.withConfig({
  displayName: "Text__InlineText"
})(["", " &&{", " ", "}"], _ref => {
  let {
    cascade
  } = _ref;
  return !cascade && css(["all:initial;", ""], tombac.typography.text);
}, textStyles, propStyling);
export const Text = styled.p.withConfig({
  displayName: "Text"
})(["", " &&{", " ", "}"], _ref2 => {
  let {
    cascade
  } = _ref2;
  return !cascade && css(["all:initial;display:block;", ""], tombac.typography.text);
}, textStyles, propStyling);
//# sourceMappingURL=Text.js.map